import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarClock, ArrowRight } from 'lucide-react';
import { RENTREE } from '../data/constants';
function daysUntil(target: Date) {
  const diff = target.getTime() - Date.now();
  return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
}

/**
 * Bandeau d'urgence affiché en haut du site.
 * Rappelle la prochaine rentrée et le nombre de jours restants
 * pour inciter à candidater sans attendre.
 */
export function RentreeBanner() {
  const [days, setDays] = useState(() => daysUntil(RENTREE.date));
  useEffect(() => {
    const id = window.setInterval(() => setDays(daysUntil(RENTREE.date)), 1000 * 60 * 60);
    return () => window.clearInterval(id);
  }, []);
  if (days === 0) return null;
  return <div className="bg-brand-orange text-white" data-id="element-639" data-mp="3hq1b4bo6jej4">
      <div className="container flex flex-wrap items-center justify-center gap-x-4 gap-y-2 py-2.5 text-sm text-center" data-id="element-640" data-mp="3hrckcr0e9ehm">
        <span className="flex items-center gap-2 font-bold" data-id="element-641" data-mp="2tmaewpxwgeus">
          <CalendarClock className="w-4 h-4 shrink-0" data-id="element-642" data-mp="2tkplx4r8h3z1" />
          Offres d'alternance disponibles — démarrage immédiat possible en
          entreprise
        </span>
        <span className="hidden sm:inline text-white/70" data-id="element-643" data-mp="32eu655bv3h5l">•</span>
        <span className="font-medium" data-id="element-644" data-mp="32gf0atu9ky2x">
          Rentrée en formation le{' '}
          <strong className="font-extrabold" data-id="element-645" data-mp="2ydsdx8gd45d4">{RENTREE.dateLabel}</strong> · plus
          que {days} jours
        </span>
        <Link to="/candidater" className="group inline-flex items-center gap-1.5 font-bold underline underline-offset-4 hover:text-primary-dark transition-colors" data-id="element-646" data-mp="2ap95msxbbsl1">
          Je candidate
          <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" data-id="element-647" data-mp="2ep9kgeobq5sm" />
        </Link>
      </div>
    </div>;
}